export default __webpack_public_path__ + "static/media/Hersteller-Piktogramm.609eb259.svg";